import React, { useState, useEffect } from "react";
import { ArchiveTopBox, ImportantNews2, Footer2 } from "../../components";
import LeftPage from "../../assets/icon/NewsIcons/LeftPage";
import RightPage from "../../assets/icon/NewsIcons/RightPage";
import { axiosReq } from "../../commons/axiosReq";
import { apiAsset } from "../../commons/inFormTypes";
import { useLocation,useSearchParams } from "react-router-dom";
import moment from 'jalali-moment';

const Tag = () => {

            const location = useLocation();
            const decodedUrl = decodeURIComponent(location?.pathname.split("/")[2]).replace(/-/g, ' ');
            const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [reCheck, setRecheck] = useState(false);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(12);
    const [cat, setCat] = useState(10);

    const GetData = async () => {
        console.log(searchParams)
        console.log(location)
        console.log(decodedUrl)
        if(location?.pathname){
            setCat(location?.pathname)
        const writersData = await axiosReq("Admins/GetArticleByTagSlug?page=" + page + "&&pageSize=" + row + "&&search=" + search + "&&tagSlug="+location?.pathname.split("/")[2], "get");
        console.log(writersData)
        setData(writersData?.data)
        setCount(writersData?.count)
        }
    }
    useEffect(() => {

        GetData();
    }, [reCheck, search, page, row,]);

    return (
        <>
            {/* {
                data ?
                    <ArchiveTopBox imgPath={apiAsset + data[0]?.mainPicture}
                        title={data[0]?.articleTittle}
                        text={data[0]?.newsBox}
                        link={"/news/" + data[0]?.articleCategories?.category?.categorySlug + "/" + data[0]?.slug}
                        />
                    : null
            } */}


            <div>
                <div className="mx-[5.5%] flex justify-start items-center mt-[40px] b1115:mx-[1.5%] md:mx-[2%]">
                    <div
                        className="w-[38px] h-[11px]  bg-nextColor rounded-[50px] shadow-yellowShadow "></div>
                    <div
                        className="w-[11px] h-[11px] mr-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow "></div>
                    <p className="text-2xl text-mainColor2 font-IRANYekanExtra mx-[15px]"> اخبار  {decodedUrl}</p>
                </div>
            </div>
            <div className="w-[90%] mx-auto flex flex-wrap opacity-100 mt-[60px] b1115:w-[98%]">
                {
                    data?.map((news, index) => {
                        return (
                                <div className="w-[24%] mb-[30px] mx-[0.5%] a1475:w-[32%] b1115:w-[48%] md:mx-[1%] md:mb-[10px] c550:w-[98%]">
                                    <ImportantNews2
                                    imgPath={news?.mainPicture} 
                                    title={news?.articleTittle}
                                    text={news?.newsText}
                                    link={"/news/" + news?.articleCategories[0]?.category?.categorySlug + "/" + news?.slug}
                                    date={moment(news?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}
                                    time={news?.datePublished?.split("T")[1].substr(0, 5)}
                                    />
                                </div>
                            
                        )
                    })
                }
            </div>
      
            {/* <div className="w-[90%] mx-auto flex justify-center  opacity-100  md:mx-[10px] md:flex-wrap mt-[30px] md:w-full">
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news2.jpg"} title={"جلسه علنی رئیس جمهور"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news3.jpg"} title={"برگزاری اجتماع مردمی در میدان فلسطین"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news1.jpg"} title={"جلسه علنی رئیس جمهور"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news3.jpg"} title={"برگزاری اجتماع مردمی در میدان فلسطین"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
            
            </div> */}
            <div className="w-[90%] mx-auto   opacity-100  md:mx-[10px] md:flex-wrap mt-[30px] md:w-full py-3 px-3">
                <div className="flex items-center justify-center">
                        
                   
                        
                <button onClick={() => setPage(page + 1)} disabled={count <= row * page} className="mx-[8px] w-[40px] h-[40px] pl-[2px] bg-white rounded-full border-[2px] border-nextColor flex justify-center items-center">
                    <RightPage />
                </button>
                {page == 1 && page + 2 <= Math.ceil(count / row)  && (
                    <button onClick={() => setPage(page + 2)} className="mx-[8px] w-[40px] h-[40px] bg-white rounded-full border-[2px] border-nextColor flex justify-center items-center">
                        <p className="font-IRANYekanBold text-[16px] text-mainColor2">{page + 2}</p>
                    </button>
                )}
                {page < Math.ceil(count / row) && (
                    <button onClick={() => setPage(page + 1)} className="mx-[8px] w-[40px] h-[40px] bg-white rounded-full border-[2px] border-nextColor flex justify-center items-center">
                        <p className="font-IRANYekanBold text-[16px] text-mainColor2">{page + 1}</p>
                    </button>
                )}
                <button className="mx-[8px] w-[40px] h-[40px] bg-mainColor2 rounded-full border-[2px] border-mainColor2 flex justify-center items-center">
                    <p className="font-IRANYekanBold text-[16px] text-white">{page}</p>
                </button>
                {page > 1 && (
                    <button onClick={() => setPage(page - 1)} className="mx-[8px] w-[40px] h-[40px]  bg-white rounded-full border-[2px] border-nextColor flex justify-center items-center">
                        <p className="font-IRANYekanBold text-[16px] text-mainColor2">{page - 1}</p>
                    </button>
                )}
                {page == Math.ceil(count / row) && (page -2) > 0 && (
                    <button onClick={() => setPage(page - 2)} className="mx-[8px] w-[40px] h-[40px] bg-white rounded-full border-[2px] border-nextColor flex justify-center items-center">
                        <p className="font-IRANYekanBold text-[16px] text-mainColor2">{page - 2}</p>
                    </button>
                )}
                <button onClick={() => setPage(page - 1)} disabled={page === 1} className="mx-[8px] w-[40px] h-[40px] pr-[2px] bg-white rounded-full border-[2px] border-nextColor flex justify-center items-center">
                    <LeftPage />
                </button>
                    </div>
            </div>

        </>
    )
}

export default Tag;